<div class="col-md-12 stickyTitle"
    style="top:-25px; margin-top: -25px; text-align: right; background-color: white; opacity: 1;">
    <div class="PageTitle">
        <h3 style="text-align: center;" class="reduce-margin"><b>List National Corps</b></h3>
    </div>
</div>

<div [hidden]="!hidePage" class="container white_bg" style="padding-top: 40px;">
    <h2 style="padding-left: 35%;" [hidden]="!loadingCorpsBanner">Please Wait, Loading Available Corps</h2>
    <h2 style="padding-left: 35%;" [hidden]="!savingCorpsBanner">Please Wait, Saving Corps</h2>
    <div id="preloader-wrapper">
        <div id="preloader" class="preloader2"> </div>
    </div>
</div>

<div class="row special-reduce-margin" style="margin-bottom: 0px;" [hidden]="hidePage">
    <div class="row">
        <div class="col-md-1 reduce-margin">
            <div class="row" style="width: 100px;">
                <h4><b>Template:</b></h4>
            </div>

            <div class="reduce-margin" style="width: auto;">
                <h4 style="font-size:16px; white-space: nowrap">{{ templateDesc }}</h4>
            </div>
        </div>

        <div class="col-md-11">
            <div class="col-md-offset-4">
                <div class="row">
                    <div class="col-md-1" style="width: 375px">
                        <div class="row">
                            <div style="display: inline-block; white-space:nowrap">
                                <h4><b>Client</b></h4>
                            </div>
                        </div><br>
                        <div class="row">
                            <div class="reduce-margin" style="display:inline-block; white-space: nowrap; width: 350px">
                                <reusable-typeahead-search #search0 (messageEventObject)="receiveMessageObj($event)"
                                    (messageEvent)="searchReceiveMessage($event)" [events]="clientEventSubject.asObservable()">
                                </reusable-typeahead-search>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-1" style="width: 125px">
                        <div class="row">
                            <div style="display: inline-block; white-space:nowrap">
                                <h4><b>From Corp</b></h4>
                            </div>
                        </div><br>
                        <div class="row">
                            <div class="reduce-margin" style="display:inline-block; white-space: nowrap; width: 100px">
                                <reusable-corp-search #fromCorp (messageEvent)="fromReceiveMessage($event)"
                                    [events]="fromEventSubject.asObservable()"></reusable-corp-search>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-1" style="width: 125px">
                        <div class="row">
                            <div style="display: inline-block; white-space:nowrap">
                                <h4><b>To Corp</b></h4>
                            </div>
                        </div><br>
                        <div class="row">
                            <div class="reduce-margin" style="display:inline-block; white-space: nowrap; width: 100px">
                                <reusable-corp-search #toCorp (messageEvent)="toReceiveMessage($event)"
                                    [events]="toEventSubject.asObservable()"></reusable-corp-search>
                            </div>
                        </div>
                    </div>

                    <br><br><br>
                    <div class="col-md-1" style="display:inline-block; white-space: nowrap;">
                        <!-- Button Row -->
                        <div id="buttonRow1" style=" display:inline-block; white-space: nowrap;">
                            <div style="display:inline-block; white-space: nowrap;">
                                <button (click)="clientSearchButton()" type="button" class="btn btn-md btn-primary"
                                    style="margin: auto;">Search</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <hr>
    <br>

    <!-- left side -->
    <div class="reduce-margin" style="border-right: 0px solid lightsteelblue; height: auto;">
        <div class="col-md-5 reduce-margin">
            <div class="row">
                <div class="col-md-1" style="width: auto;">
                    <h4 style="display: inline-block; white-space: nowrap;"><b>Associated Corps</b></h4>
                </div>

                <!-- Row 2 -->
                <div class="col-md-1" style="white-space: nowrap; width: auto;">
                    <h4><b>&nbsp;&nbsp;&nbsp;&nbsp;Filter Corp:</b></h4>
                </div>

                <div class="col-md-1" style="width: 150px;">
                    <mat-form-field class="reduce-margin no-wrapping" style="width: 100px">
                        <input type="text" matInput [formControl]="assocFilterControl">
                    </mat-form-field>
                </div>

                <div class="col-md-1">
                    <button aria-hidden="true" (click)="downloadCsv()" matTooltip="Export to CSV"
                        class="btn btn-md btn-primary">Export</button>
                </div>
            </div>

            <div class="row">
                <!-- source corp table  -->
                <div class="col-md-14" style="max-width: auto;">
                    <reusable-table-app #table0 (messageEvent)="table0ReceiveMessage($event)"
                        [events]="tableEventSubject.asObservable()" [displayedColumns]="displayedColumns"
                        [columns]="columns" [pageSizeOptions]="pageSizeOptions"
                        [checkboxHeader]="checkboxHeader"></reusable-table-app>
                </div>
            </div>
        </div>

        <div class="col-md-2" style="margin-left: -5px; margin-right: 0px; padding-top: 50px;">
            <div class="col-md-1" style="width: 50px;">
                <a style="cursor: pointer;" (click)="dissacCorps()">
                    <mat-icon class="nc-icon-glyph arrows-1_circle-right-09" style="transform: scale(3);">
                    </mat-icon>
                </a>
            </div>

            <div class="col-md-1" style="display: inline-block; white-space: nowrap">
                <a style="cursor: pointer;" (click)="assocCorps()">
                    <mat-icon class="nc-icon-glyph arrows-1_circle-left-10" style="transform: scale(3);">
                    </mat-icon>
                </a>
            </div>
        </div>

        <div class="col-md-5 reduce-margin" style="margin-left: 0px; margin-right: 0px;">
            <div class="row">
                <div class="col-md-1">
                    <h4
                        style="margin-left:-15px; padding-left:0px; padding-top:0px; display: inline-block; white-space: nowrap;">
                        <b>Available Corps</b></h4>
                </div>
            </div>
            <div class="row" style="margin-bottom: 0px;">
                <!-- target table -->
                <reusable-table-app #table1 (messageEvent)="table1ReceiveMessage($event)"
                    [events]="table1EventSubject.asObservable()" [displayedColumns]="displayedColumns1"
                    [columns]="columns1" [pageSizeOptions]="pageSizeOptions"
                    [checkboxHeader]="checkboxHeader"></reusable-table-app>
            </div>
        </div>
        <br><br><br><br>
    </div>
</div>

<div style="background-color: white; overflow: hidden;">
    <hr style="margin-top: 0px;">
    <div class="row" id="buttonRow">
        <div class="col-md-1 col-md-offset-4 reduce-margin">
            <button [disabled]="toggleSaveButton" (click)="saveButton()" type="button" class="btn btn-md btn-primary"
                style="margin: auto;">Save</button>
        </div>

        <div class="col-md-1 col-md-offset-1 reduce-margin">
            <button (click)="cancelButton()" type="button" class="btn btn-md btn-primary"
                style="margin: auto;">Cancel</button>
        </div>
    </div>
</div>
